import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/app/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
    console.log(environment.apiUrl);
  }

  getUsers(roleId?: number): Observable<any[]> {
    const url = roleId
      ? `${this.apiUrl}/users?role_id=${roleId}`
      : `${this.apiUrl}/users`;
    return this.http.get<any[]>(url);
  }

  getRoles(userId?: number): Observable<any[]> {
    const url = userId
      ? `${this.apiUrl}/roles?user_id=${userId}`
      : `${this.apiUrl}/roles`;
    return this.http.get<any[]>(url);
  }

  getPermissions(roleId?: number): Observable<any[]> {
    const url = roleId
      ? `${this.apiUrl}/permissions?role_id=${roleId}`
      : `${this.apiUrl}/permissions`;
    return this.http.get<any[]>(url);
  }

  getRolePermissions(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/role-permissions`);
  }

  createUser(data: any) {
    return this.http.post(`${this.apiUrl}/user`, data);
  }
  updateUser(data: any, userId: number) {
    return this.http.post(`${this.apiUrl}/user/${userId}?_method=PUT`, data);
  }
  updateRole(data: any, roleId: number) {
    return this.http.post(`${this.apiUrl}/role/${roleId}?_method=PUT`, data);
  }
  updatePermission(data: any, permissionId: number) {
    return this.http.post(
      `${this.apiUrl}/permission/${permissionId}?_method=PUT`,
      data
    );
  }
  deleteUser(userId: number) {
    return this.http.delete(`${this.apiUrl}/delete-user/${userId}`);
  }
  deleteRole(roleId: number) {
    return this.http.delete(`${this.apiUrl}/delete-role/${roleId}`);
  }
  deletePermission(permissionId: number) {
    return this.http.delete(`${this.apiUrl}/delete-permission/${permissionId}`);
  }
  createRole(data: any) {
    return this.http.post(`${this.apiUrl}/role`, data);
  }
  createPermission(data: any) {
    return this.http.post(`${this.apiUrl}/permission`, data);
  }
  assignRolesToUser(userId: string, roles: string[]) {
    return this.http.post(`${this.apiUrl}/users/${userId}/assign-roles`, {
      roles,
    });
  }
  assignPermissionsToRole(roleId: string, permissions: string[]) {
    return this.http.post(`${this.apiUrl}/roles/${roleId}/assign-permissions`, {
      permissions,
    });
  }
}
